namespace $ {

	export function $shm_projects_tasks_list( project_id: string ): readonly $shm_projects_task_record[] {
		return $mol_state_local.value< readonly $shm_projects_task_record[] >( `$shm_projects_tasks(${ project_id })` ) ?? []
	}

}
